import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import PMBInputNumber from 'components/PMBInputNumber'
import { formatInputNumber } from 'utility/Utils'
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap'
import { useEditNoTrxMutation } from '../dashboardApiSlice'


const ModalEditNoTrx = ({ isOpen, toggle, data, refetch, isShared }) => {
  const [label, setLabel] = useState('')
  const [editNoTrx, { isLoading }] =
    useEditNoTrxMutation()


  useEffect(() => {
    if (isOpen && data) {
      setLabel(data?.orderDetail?.transaction_number || '')
    }
  }, [isOpen, data])

  const handleSubmit = async () => {
    try {
      await editNoTrx({
        tradeshortcutId: data?.tradeshortcutId,
        transactionNumber: label,
      }).unwrap()
      enqueueSnackbar('Nomor Transaksi berhasil diubah', { variant: 'success' })
      refetch()
      toggle()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message ||
        error?.data?.message ||
        'Terjadi kendala',
        { variant: 'error' },
      )
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="detail-transaction-modal-edit-no-trx">
      <ModalHeader toggle={toggle} data-testid="detail-transaction-close-button">Ubah Nomor Transaksi</ModalHeader>
      <ModalBody>

        <div>
          <label className="fw-semibold mb-1 d-block">Nomor Transaksi</label>
          <Input
            value={label}
            onChange={(e) => {
              setLabel(e.target.value)
            }}
            placeholder='Masukkan nomor transaksi'
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="btn-cancel"
          outline
          onClick={toggle}
          disabled={isLoading}
          data-testid="detail-transaction-modal-edit-no-trx-cancel"
        >
          Batal
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={false}
          data-testid="detail-transaction-modal-edit-no-trx-submit"
        >
          {isLoading ? <Spinner size="sm" /> : 'Simpan'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditNoTrx
